import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Alert,
  AlertIcon,
  Text,
  useToast,
  Image,
} from "@chakra-ui/react";
import { getAboutHeader, updateAboutHeader } from "src/store/settings/about/aboutHeaderSlice";
import React, { useEffect } from "react";
import { baseUrl } from "src/utilities/axios";

const Header = () => {
  const { t } = useTranslation();
  const toast = useToast({ position: "top", status: "success", duration: 3000 });
  const dispatch = useDispatch();
  const aboutHeader = useSelector(state => state.aboutHeader);

  const {
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setValue
  } = useForm();

  watch(["background"]);

  useEffect(() => {
    dispatch(getAboutHeader())
      .unwrap()
      .then(res => {
        reset(res.data)
      })
      .catch(e => console.log(e))
  }, [dispatch, reset]);

  return (
    <form onSubmit={handleSubmit((values, even) => {
      dispatch(updateAboutHeader(even.target))
        .unwrap()
        .then(_ => {
          toast({ description: "settings updated" });
        })
        .catch(e => {
          window.scrollTo(0, 0);
        })
    })}>
      <Stack spacing={6}>
        {aboutHeader?.error && (
          <Alert status="error" variant="left-accent">
            <AlertIcon />
            <Text>{aboutHeader?.error || "-"}</Text>
          </Alert>
        )}

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.about.header.background")}
          </FormLabel>
          <Input
            type="file" placeholder={t("pages.settings.about.header.background")}
            height="48px" borderRadius={4} pt={2}
            {...register("background")}
          />
          {typeof (getValues("background")) === "string" && getValues("background") && (
            <>
              <input type="hidden" name="edited_background" value={getValues("background")} />
              <Image mt={2} src={`${baseUrl}/header/${getValues("background")}`} height="150px" objectFit="contain" />
              <Button mt={2} bg="red.600" color="white" type="button" onClick={() => setValue("background", null)}>
                {t("general.delete")}
              </Button>
            </>
          )}
        </FormControl>

        <Button
          type="submit"
          bg="green.600"
          isLoading={aboutHeader.isLoading}
          color="white"
          textTransform="capitalize"
          _hover={{ bg: "green.600" }}
        >
          {t("general.save")}
        </Button>
      </Stack>
    </form>
  )
}

export default Header